// ============================================
// GOODBYE PHRASES BY LANGUAGE (ISO codes)
// ============================================
// Extracted from VoiceBotPanel.tsx in Wave 1 of the widget refactor.
// Pure utilities — no React, no side effects.

export const GOODBYE_PHRASES: Record<string, readonly string[]> = {
  he: ['להתראות', 'ביי', 'ביביי', 'נתראה', 'יום טוב', 'להשתמע', 'סיימתי', 'אני מסיים', 'אפשר לסיים'],
  en: ['bye', 'goodbye', 'thanks', 'thank you', 'see you', 'take care', 'gotta go', 'i\'m done'],
  ru: ['пока', 'до свидания', 'спасибо', 'увидимся', 'всего доброго'],
  fr: ['au revoir', 'merci', 'à bientôt', 'salut', 'bonne journée'],
  ar: ['مع السلامة', 'شكرا', 'وداعا', 'إلى اللقاء'],
} as const

export const escapeRegex = (text: string) => text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

export const includesPhraseBoundary = (text: string, phrase: string) => {
  if (!phrase.trim()) return false
  const boundaryPattern = new RegExp(`(^|[\\s,.;:!?()\\-])${escapeRegex(phrase)}($|[\\s,.;:!?()\\-])`, 'i')
  return boundaryPattern.test(text)
}
